import GenericDictionaryPage from "./GenericDictionaryPage";
import { getClaimPersonalRelationship } from "../api/claimPersonalRelationship";

export default function ClaimPersonalRelationship() {
    return (
        <GenericDictionaryPage
            tableKey="claimPersonalRelationship"
            filterTableKey="generic"
            fetchData={getClaimPersonalRelationship}
            titleKey="genericDic:claimPersonalRelationship"
            newButtonLabel={({ t }) =>
                t("genericDic:claimPersonalRelationshipButtonNew", {
                    tableName: t("genericDic:claimPersonalRelationship").toLowerCase()
                })
            }
        />
    );
}
